import { Dispatch, SetStateAction } from 'react'
import { CloseOutlined } from '@mui/icons-material'
import { Backdrop, IconButton, Portal, useTheme } from '@mui/material'

import Search from '../search'

import useStyles from './index.styles'

interface IProps {
  showSearch: boolean
  setShowSearch: Dispatch<SetStateAction<boolean>>
  onClose: () => void
  setOpenModal: Dispatch<SetStateAction<boolean>>
  setSelectedFolder: Dispatch<SetStateAction<ISearchResultAccount | undefined>>
}

const FolderSelectionSearch = ({ showSearch, setShowSearch, onClose, setOpenModal, setSelectedFolder }: IProps) => {
  const classes = useStyles
  const theme = useTheme()

  const closeSearch = () => {
    setShowSearch(false)
    onClose()
  }

  return (
    <Portal>
      <Backdrop open={showSearch} onClick={closeSearch} sx={classes.backdrop}>
        <div style={classes.backdropSearchContainer(theme)} onClick={(e) => e.stopPropagation()}>
          <Search
            closeOverlay={onClose}
            allowedTypes={['accounts']}
            onSelect={(item) => {
              setSelectedFolder(item as ISearchResultAccount)
              setOpenModal(true)
              setShowSearch(false)
            }}
          />
        </div>
        <IconButton onClick={closeSearch} aria-label="Close search" sx={classes.backdropCloseIconButton}>
          <CloseOutlined sx={classes.backdropCloseIcon} />
        </IconButton>
      </Backdrop>
    </Portal>
  )
}

export default FolderSelectionSearch
